/*
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd. All rights reserved.
This file contains Protected Intellectual Property owned by Kaleida Ltd and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (explicitly not developed by Kaleida), whether or not such application forms part of the Platform.
For the avoidance of doubt, the inclusion of any application within the Platform does not of itself grant any right to use Protected Intellectual Property in that application unless that application was developed by Kaleida.
*/

// IP-NOTICE: PROTECTED
import { Component, Output, Inject, EventEmitter } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';

export interface ConfirmModel {
  title: string,
  message: string,
  result: boolean
}

@Component({
    selector: 'confirmation',
    templateUrl: './confirmation-modal.component.html',
    standalone: false
})


export class ConfirmationModalComponent  {

    @Output() 
    onClose = new EventEmitter<ConfirmModel>(true);
  
  constructor(
    public dialogRef: MatDialogRef<ConfirmationModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmModel) {
      dialogRef.disableClose = true;
    }
  
  confirmed() {
    this.data.result = true;
    this.onClose.emit(this.data);
    this.dialogRef.close();
  }

  cancelled() {
    this.data.result = false;
    this.onClose.emit(this.data);
    this.dialogRef.close();
  }

  
}


